import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import VirtualReceptionistFAQ from '../components/VirtualReceptionistFAQ';
import VirtualReceptionistHero from '../components/VirtualReceptionistHero';
import {
  AiAdvantageSection,
  HumanServiceSection,
  SavingsSection,
  SwitchingSection,
  VirtualComparisonSection
} from '../components/VirtualReceptionistSections';
import { virtualReceptionistSchema } from '../data/virtualReceptionistPageContent';

const VirtualReceptionistPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Virtual Receptionist for Small Business | AutoReception';

    const description = '24/7 virtual receptionist for small business with instant booking, call routing, and predictable costs below traditional human services.';
    let meta = document.querySelector('meta[name="description"]');

    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }

    meta.content = description;

    const schema = document.createElement('script');
    schema.type = 'application/ld+json';
    schema.textContent = JSON.stringify(virtualReceptionistSchema);
    document.head.appendChild(schema);

    return () => schema.remove();
  }, []);

  return (
    <div className="animate-in fade-in duration-700">
      <VirtualReceptionistHero />
      <HumanServiceSection />
      <AiAdvantageSection />
      <VirtualComparisonSection />
      <SavingsSection />
      <SwitchingSection />
      <VirtualReceptionistFAQ />
      <section className="relative overflow-hidden bg-blue-700 px-4 py-24 text-center sm:px-6 lg:px-8">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.16),transparent_55%)]" />
        <div className="relative mx-auto max-w-4xl">
          <p className="mb-4 text-sm font-bold uppercase tracking-widest text-blue-100">Ready to compare?</p>
          <h2 className="text-4xl font-extrabold text-white md:text-5xl">Replace expensive hold times with instant 24/7 coverage.</h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-blue-100">Try the live audio demo, then test AutoReception on your own business workflow with a risk-free trial.</p>
          <div className="mt-8 flex flex-col justify-center gap-4 sm:flex-row">
            <Link to="/ai-receptionist-for-small-business" className="rounded-full bg-white px-8 py-4 font-bold text-blue-700 transition hover:bg-blue-50">Try AutoReception Free</Link>
            <Link to="/best-ai-receptionist-for-small-business" className="rounded-full border border-blue-200/50 px-8 py-4 font-bold text-white transition hover:bg-blue-600">Compare More Tools</Link>
          </div>
        </div>
      </section>
      <section className="px-4 py-16 text-center sm:px-6 lg:px-8">
        <p className="text-slate-400">
          Explore the <Link to="/ai-receptionist-for-small-business" className="text-blue-400 hover:underline">complete AI phone answering setup</Link> or <Link to="/best-ai-receptionist-for-small-business" className="text-blue-400 hover:underline">compare the best AI receptionist software</Link>.
        </p>
      </section>
    </div>
  );
};

export default VirtualReceptionistPage;